import { Button, Stack } from "@mui/material";
import { NavLink } from "react-router-dom";
import { PageHeader } from "../components/ui";

const CARD_ACTIONS = [
  { to: "/customers", label: "Müşteriler" },
  { to: "/suppliers", label: "Tedarikçiler" },
  { to: "/users", label: "Kullanıcılar" },
  { to: "/materials", label: "Malzemeler" },
  { to: "/work-center-groups", label: "Makine Grupları" },
  { to: "/work-centers", label: "İş Merkezleri" },
  { to: "/knives", label: "Bıçaklar" },
  { to: "/molds", label: "Kalıplar" },
  { to: "/shifts", label: "Vardiyalar" },
  { to: "/downtime-reasons", label: "Duruşlar" },
];

function currentUserRole() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null")?.role || null;
  } catch {
    return null;
  }
}

export default function CardsPage() {
  const role = currentUserRole();
  // Kullanıcılar kartı "yonetici" rolüne özel; admin de görür. Depocu sadece
  // Tedarikçiler kartını görür.
  const visibleActions =
    role === "yonetici" || role === "admin"
      ? CARD_ACTIONS
      : role === "depocu"
        ? CARD_ACTIONS.filter((a) => a.to === "/suppliers")
        : CARD_ACTIONS.filter((a) => a.to !== "/users");

  return (
    <Stack spacing={2}>
      <PageHeader title="Kartlar" subtitle="Sistem kartlarına erişin." />

      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1.25}
        useFlexGap
        flexWrap="wrap"
        sx={{ maxWidth: 760 }}
      >
        {visibleActions.map((action) => (
          <Button
            key={action.to}
            component={NavLink}
            to={action.to}
            variant="contained"
            sx={{
              minWidth: { xs: "100%", sm: 180 },
              justifyContent: "flex-start",
              textTransform: "none",
              fontWeight: 700,
            }}
          >
            {action.label}
          </Button>
        ))}
      </Stack>
    </Stack>
  );
}
